import React from "react";

//Componentes
import GetTrofeos from "./trofeos";

const BoxTrofeos = () => {
    return <GetTrofeos />;
};

export default BoxTrofeos;
